import { cn } from '../../utils/cn';
import { Icon } from './Icon';

/**
 * Dashboard stat kartı — ikon + başlık + metrik + delta.
 */
export default function StatCard({
  icon,
  label,
  value,
  delta,
  deltaKind = 'up', // 'up' | 'down' | 'neutral'
  hint,
  accent = 'primary', // primary | success | warning | danger
}) {
  const accents = {
    primary: 'bg-primary-50 text-primary-700',
    success: 'bg-success-50 text-success-700',
    warning: 'bg-warning-50 text-warning-700',
    danger: 'bg-danger-50 text-danger-700',
    purple: 'bg-purple-50 text-purple-700',
  };

  const deltaColors = {
    up: 'text-success-600',
    down: 'text-danger-600',
    neutral: 'text-neutral-500',
  };

  return (
    <div className="rounded-xl border border-neutral-200 bg-white p-5 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-xs font-medium text-neutral-500 uppercase tracking-wider">{label}</p>
          <p className="mt-1 text-2xl font-bold text-neutral-900">{value}</p>
          {(delta || hint) && (
            <div className="mt-1.5 flex items-center gap-2 text-xs">
              {delta && (
                <span className={cn('font-medium', deltaColors[deltaKind])}>
                  {deltaKind === 'up' ? '↑' : deltaKind === 'down' ? '↓' : '•'} {delta}
                </span>
              )}
              {hint && <span className="text-neutral-500">{hint}</span>}
            </div>
          )}
        </div>
        {icon && (
          <div className={cn('p-2.5 rounded-lg', accents[accent])}>
            <Icon name={icon} className="h-5 w-5" />
          </div>
        )}
      </div>
    </div>
  );
}
